import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import "isomorphic-fetch";

import VueI18n from "vue-i18n";
import * as dataEN from "./data/productsEN.json";
import * as dataLV from "./data/productsLV.json";
import * as systemEN from "./data/systemEN.json";
import * as systemLV from "./data/systemLV.json";
import * as tagsEN from "./data/tagsEN.json";
import * as tagsLV from "./data/tagsLV.json";
import * as feedbacksEN from "./data/feedbacksEN.json";
import * as feedbacksLV from "./data/feedbacksLV.json";

require("es6-promise").polyfill();
Vue.use(VueI18n);

Vue.config.productionTip = false;

// Might be not needed
Object.defineProperty(Vue.prototype, "$bus", {
  get: function() {
    return this.$root.bus;
  }
});

const store = {
  debug: true,
  bus: new Vue({}),
  state: {
    sort: ["skatīt visus"],
    tags: tagsLV.tags,
    products: dataLV.products,
    feedbacks: feedbacksLV.feedbacks,
    system: systemLV.translations,
    selectedProducts: [],
    popupActive: false,
    orderProduct: null,
    showOrderCard: false,
    showFeedbacks: false,
    orderType: "",
    showMessageStatus: false,
    messageStatusText:
      "<h2>Paldies!</h2><br>Jūsu ziņa ir nosūtīta.<br>Mēs ar Jums drīzumā sazināsimies.",
    lang: "lv",
    sendInProgress: false
  },
  messages: {
    en: {
      message: {
        hello: "hello world",
        successSent:
          "<h2>Success!</h2><br>Your message has been sent.<br>We will get back to you as fast as we can.",
        failSent:
          "<h2>Oops!</h2><br>Something went wrong while we were trying to deliver your message."
      }
    },
    lv: {
      message: {
        hello: "sveika, pasaule",
        successSent:
          "<h2>Paldies!</h2><br>Jūsu ziņa ir nosūtīta.<br>Mēs ar Jums drīzumā sazināsimies.",
        failSent:
          "<h2>Ak vai!</h2><br>Kamēr mēginājām nogādāt Jūsu ziņu, kaut kas nogāja greizi."
      }
    }
  },
  showOrder({ orderType, orderProd = this.state.products }) {
    if (this.debug) console.log(`showing order for ${orderType}`);

    console.log(orderProd);
    this.state.popupActive = true;
    this.state.orderProduct = orderProd;
    this.state.showOrderCard = true;
    this.state.orderType = orderType;
  },
  sendOrder({ data }) {
    if (data.selectedProducts.length) {
      const filteredProds = this.state.products.filter(
        prod => data.selectedProducts.indexOf(prod.id) >= 0
      );
      data.products = filteredProds.map(prod => prod.title);
    } else {
      data.products = data.selectedProducts.title;
    }
    data.selectedProducts = null;

    console.log(data);
    console.log("sending the order here");
    console.log(JSON.stringify(data));
    this.state.sendInProgress = true;

    const url = "/backend/mail.php";
    fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(response => response.text())
      .then(html => {
        if (html.indexOf("Success!") >= 0) {
          switch (this.state.lang) {
            case "en":
              this.state.messageStatusText = this.messages.en.message.successSent;
              break;
            default:
              this.state.messageStatusText = this.messages.lv.message.successSent;
              break;
          }
        } else {
          switch (this.state.lang) {
            case "en":
              this.state.messageStatusText = this.messages.en.message.failSent;
              break;
            default:
              this.state.messageStatusText = this.messages.lv.message.failSent;
              break;
          }
        }
        this.state.showMessageStatus = true;
        // console.log(html)
        this.state.sendInProgress = false;
      });
  },
  sendFeedback({ data }) {
    console.log("sending the feedback here");
    console.log(JSON.stringify(data));

    this.state.sendInProgress = true;
    const url = "/backend/mail.php";
    fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(response => response.text())
      .then(html => {
        if (html.indexOf("Success!") >= 0) {
          switch (this.state.lang) {
            case "en":
              this.state.messageStatusText = this.messages.en.message.successSent;
              break;
            default:
              this.state.messageStatusText = this.messages.lv.message.successSent;
              break;
          }
        } else {
          switch (this.state.lang) {
            case "en":
              this.state.messageStatusText = this.messages.en.message.failSent;
              break;
            default:
              this.state.messageStatusText = this.messages.lv.message.failSent;
              break;
          }
        }
        this.state.showMessageStatus = true;
        this.state.sendInProgress = false;
      });
  },
  hideOrder() {
    if (this.debug) console.log(`order is complete OR closed`);

    this.state.popupActive = false;
    this.state.orderProduct = null;
    this.state.showOrderCard = false;
    this.state.orderType = "";
  },
  changeLanguage(lang) {
    switch (lang) {
      case "en":
        this.state.products = dataEN.products;
        this.state.system = systemEN.translations;
        this.state.tags = tagsEN.tags;
        this.state.feedbacks = feedbacksEN.feedbacks;
        this.state.messageStatusText = this.messages.en.message.successSent;
        this.state.sort = ["view all"];
        this.state.lang = "en";
        break;
      default:
        this.state.products = dataLV.products;
        this.state.system = systemLV.translations;
        this.state.feedbacks = feedbacksLV.feedbacks;
        this.state.tags = tagsLV.tags;
        this.state.messageStatusText = this.messages.lv.message.successSent;
        this.state.sort = ["skatīt visus"];
        this.state.lang = "lv";
        break;
    }
  }
};

const i18n = new VueI18n({
  locale: "lv"
});

new Vue({
  i18n,
  data: store,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js